module.exports = __webpack_public_path__ + "img/unload-4-3.11a7b6bb.png";